import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import '@babel/polyfill'

import VeeValidate from "./plugins/VeeValidate"
import Convert from "./plugins/Convert"
import VueQuillEditor from "./plugins/VueQuillEditor"
import VueGoogleMaps from "./plugins/VueGoogleMaps"
import VueApexCharts from "./plugins/VueApexCharts"
import VueAwesomeSwiper from "./plugins/VueAwesomeSwiper"
import VueSocialSharing from "./plugins/VueSocialSharing"
import VueZoomer from "./plugins/VueZoomer"
import Firebase from "./plugins/Firebase"

import VueHtml2Canvas from "./plugins/VueHtml2Canvas"

import '@/assets/css/main.css'

import { TokenService } from "@/service/Storage.Service.js"

if (TokenService.getToken()) {
  store.commit("setToken", TokenService.getToken())
  store.commit("setUser", JSON.parse(TokenService.getUser()))
  store.commit("setMenu", JSON.parse(TokenService.getMenu()))
  
  store.commit("setReload", TokenService.getReload())

  store.commit("setFilter", JSON.parse(TokenService.getFilter()))
}

store.commit("setCompany", JSON.parse(TokenService.getCompany()))
store.commit("setColor", TokenService.getColor())

store.commit("setFcm", TokenService.getFcm())

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  Convert,
  VeeValidate,
  VueQuillEditor,
  VueGoogleMaps,
  VueApexCharts,
  VueAwesomeSwiper,
  VueSocialSharing,
  Firebase,
  VueZoomer,
  VueHtml2Canvas,
  render: h => h(App)
}).$mount('#app')
